<template>
  <div
    class="about-us-background"
    :style="{
      background: `linear-gradient(0deg, rgba(255, 255, 255, 0.95) 0%, rgba(255, 255, 255, 0.95) 100%), url('') lightgray 0% 0% / 35.15625px 35.15625px repeat;`,
    }"
  >
    <v-main>
      <v-container>
        <h2 class="section-name">Unsere Mission</h2>
        <v-row
          no-gutters
          justify="space-around"
          :style="$vuetify.breakpoint.smAndDown ? 'margin: 34px 0px;' : 'margin: 64px 0px'"
        >
          <div class="about-us-card">
            <v-row no-gutters justify="center">
              <div class="about-us-card-icon">
                <img
                  src="@/assets/img/aboutUsIcon/successCheckIcon.svg"
                  width="48px"
                  height="48px"
                  alt="icon"
                />
              </div>
            </v-row>
            <h4 class="about-us-card-title">Entlastung</h4>
            <span>
              Wir nehmen Ihnen den administrativen Aufwand ab, damit Sie sich
              voll und ganz auf Ihr Kerngeschäft konzentrieren können.
            </span>
          </div>
          <div class="about-us-card">
            <v-row no-gutters justify="center">
              <div class="about-us-card-icon">
                <img
                  src="@/assets/img/aboutUsIcon/eyeIcon.svg"
                  width="48px"
                  height="48px"
                  alt="icon"
                />
              </div>
            </v-row>
            <h4 class="about-us-card-title">Transparenz</h4>
            <span>
              Klare, verständliche Zahlen und Beratung – ohne Überraschungen.
            </span>
          </div>
          <div class="about-us-card">
            <v-row no-gutters justify="center">
              <div class="about-us-card-icon">
                <img
                  src="@/assets/img/aboutUsIcon/lightningIcon.svg"
                  width="48px"
                  height="48px"
                  alt="icon"
                />
              </div>
            </v-row>
            <h4 class="about-us-card-title">Flexibilität</h4>
            <span
              >Individuelle Lösungen, maßgeschneidert auf die Bedürfnisse jedes
              Kunden, unabhängig von Branche oder Unternehmensgröße.</span
            >
          </div>
          <div class="about-us-card">
            <v-row no-gutters justify="center">
              <div class="about-us-card-icon">
                <img
                  src="@/assets/img/aboutUsIcon/lampIcon.svg"
                  width="48px"
                  height="48px"
                  alt="icon"
                />
              </div>
            </v-row>
            <h4 class="about-us-card-title">Innovation</h4>
            <span>
              Wir setzen moderne Technologien und Tools wie Bexio ein, um
              effiziente und ortsunabhängige Zusammenarbeit zu ermöglichen.
            </span>
          </div>
        </v-row>
      </v-container>
    </v-main>
    <img
      src="@/assets/img/Backgrounds/ourServiceBackgroundTop.svg"
      width="100%"
      height="auto"
      alt="background"
      style="position: absolute; z-index: 100;bottom: 0; left: 0;"
    />
  </div>
</template>

<script>
export default {};
</script>

<style scoped>
.about-us-background {
  background: linear-gradient(
      0deg,
      rgba(255, 255, 255, 0.95) 0%,
      rgba(255, 255, 255, 0.95) 100%
    ),
    url(<path-to-image>) lightgray 0% 0% / 35.15625px 35.15625px repeat;
  padding: 80px 0px;
  position: relative;
}
.about-us-card {
  border-radius: 8px;
  padding: 33px;
  border: 1px solid #e9e4d8;
  background: rgba(255, 255, 255, 0.8);
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1),
    0 4px 6px -4px rgba(0, 0, 0, 0.1);
  backdrop-filter: blur(2px);
  color: #3e7459;
  text-align: center;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 26px;
  width: max-content;
  height: 392px;
  max-width: 264px;
  margin-bottom: 32px;
}
.about-us-card-title {
  color: #163626;
  text-align: center;
  font-size: 20px;
  font-weight: 700;
  line-height: 28px;
  margin: 22px 0px;
}
.about-us-card-icon {
  width: 80px;
  height: 80px;
  display: grid;
  place-items: center;
  border-radius: 50%;
  background: rgba(192, 149, 89, 0.1);
}
@media (width <= 900px) {
  .about-us-card {
    width: 100%;
    max-width: none;
    margin-bottom: 16px;
    height: max-content;
  }
  .about-us-card-icon {
    width: 64px;
    height: 64px;
  }
  .about-us-card-title {
    font-size: 18px;
  }
}
</style>